export const GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST = "GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_REQUEST";
export const GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS = "GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_SUCCESS";
export const GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE = "GET_GLOBAL_PROJECT_SETTINGS_TEMPLATE_BY_ID_FAILURE";

export const RESET_MASTER_SETTINGS_TEMPLATE_REDUCER = "RESET_MASTER_SETTINGS_TEMPLATE_REDUCER";
